import HomePage from "@/containers/home";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/backgammon/")({
	component: () => <HomePage />,
});
